import React, { useState, useEffect } from "react";
import configuration from "../../../config";
import DataTable from "../../../components/MDataTable";
import { toast } from "react-toastify";
// import { Link } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";

let Id = "";
// List Settings
function Summary() {
  const [isLoader, setIsLoader] = useState(false);
  const columns = [
    {
      title: "ID",
      field: "withdraw_request_id",
    },
    { title: "Amount", field: "amount" },
    { title: "Date", field: "created_at" },
    {
      title: "Status",
      field: "status",
      width: "5%",
      render: (rowData) => (
        <span
          className={
            rowData.status === "approve"
              ? "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-green-100 text-green-800 capitalize"
              : "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-red-100 text-red-800 capitalize"
          }
        >
          {" "}
          {rowData.status === "approve" ? "approved" : "rejected"}
        </span>
      ),
    },
    {
      title: "Action",
      field: "status",
      width: "5%",
      render: (rowData) =>
        rowData.status === "pending" ? (
          <>
            <button
              onClick={(e) =>
                handleAction("approve", rowData.withdraw_request_id)
              }
              type="button"
              className="mt-3 mr-3 inline-flex items-center px-3 py-2 border border-transparent text-baseleading-4 font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Approve
            </button>
            <button
              onClick={(e) =>
                handleAction("reject", rowData.withdraw_request_id)
              }
              type="button"
              className="mt-3 inline-flex items-center px-3 py-2 border border-1 text-baseleading-4 font-medium rounded-md shadow-sm text-indigo-600 bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Reject
            </button>
          </>
        ) : (
          ""
        ),
    },
  ];
  const [data, setData] = useState([]);
  const onSelectionChange = (e) => {};
  useEffect(() => {
    getData();
  }, []);

  function getData() {
    setIsLoader(true);
    var url = window.location.href;
    Id = url.substring(url.lastIndexOf("/") + 1);
    configuration
      .getAPI({
        url: "sub-user/withdraw-list",
        params: { user_id: Id },
      })
      .then((data) => {
        if (data.status === 200) {
          setData(data.payload);
        }
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  function handleAction(type, request_id) {
    setIsLoader(true);
    configuration
      .postAPI({
        url: "sub-user/withdraw-action",
        params: { type, withdraw_request_id: request_id },
      })
      .then((data) => {
        if (data.status === 200) {
          getData();
          setIsLoader(false);
          return toast.success(
            type === "approve"
              ? "The withdrawal request has been approved successfully."
              : "The withdrawal request has been rejected successfully."
          );
        } else if (data.error) {
          setIsLoader(false);
          return toast.error(data.error.message);
        } else {
          setIsLoader(false);
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }

  return (
    <div className="md:pl-8 sm:py-7 col-span-10">
      {isLoader ? <Loader /> : ""}
      <section aria-labelledby="applicant-information-title">
        <div className="bg-white shadow sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6">
            <h2
              id="applicant-information-title"
              className="text-lg leading-6 font-medium text-gray-900"
            >
              Withdrawal Requests
            </h2>
            <p className="mt-1 max-w-2xl text-base text-gray-500 text_theme">
              These details show the partner's withdrawal requests.
            </p>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
            <DataTable
              columns={columns}
              data={data}
              disabledCheckbox={true}
              onSelectionChange={onSelectionChange}
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Summary;
